var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tabClass" },
    [
      _c(
        "el-card",
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  key: 1,
                  attrs: {
                    label: _vm.$t("uploadFile.expressTimeliness"),
                    name: "timeToCustomer",
                  },
                },
                [_c("timeToCustomer")],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  key: 0,
                  attrs: {
                    label: _vm.$t("uploadFile.internalLeadTime"),
                    name: "internalTime",
                  },
                },
                [_c("internalTime")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }